import CryptoJS from "crypto-js";

export const encryptJSON = (jsonObject) => {
  try {
    // Convert JSON object to string
    const jsonString = JSON.stringify(jsonObject);

    // Encrypt using AES with PKCS7 (equivalent to PKCS5) padding
    const encryptedData = CryptoJS.AES.encrypt(
      jsonString,
      CryptoJS.enc.Utf8.parse(process.env.REACT_APP_API_MIDDLEWARE_KEY_1),
      {
        iv: CryptoJS.enc.Utf8.parse(process.env.REACT_APP_API_MIDDLEWARE_KEY_2),
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7, // Use PKCS7 padding (compatible with PKCS5)
      }
    );

    // Return the encrypted data as a base64-encoded string
    return encryptedData.toString();
  } catch (error) {
    console.error("Encryption error:", error);
    return null;
  }
};
export const decryptJSON = (encryptedData) => {
  try {
    // Decrypt using AES with PKCS7 (equivalent to PKCS5) padding
    const decryptedBytes = CryptoJS.AES.decrypt(
      encryptedData,
      CryptoJS.enc.Utf8.parse(process.env.REACT_APP_API_MIDDLEWARE_KEY_1),
      {
        iv: CryptoJS.enc.Utf8.parse(process.env.REACT_APP_API_MIDDLEWARE_KEY_2),
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7, // Use PKCS7 padding (compatible with PKCS5)
      }
    );

    // Convert decrypted bytes to a UTF-8 string
    const decryptedString = decryptedBytes.toString(CryptoJS.enc.Utf8);

    return decryptedString.toString();
  } catch (error) {
    console.error("Decryption error:", error);
    return null;
  }
};

export const fetchAPI = async (url, requestData, headers = {}) => {
  try {
    // debugger;
    // Make POST request using fetch API
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...headers,
      },
      body: encryptJSON(requestData),
    });
    // debugger;

    // Check if request was successful (status code 200)
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    // Parse response data
    const encryptedResponseData = await response.text();
    const decryptedData = decryptJSON(encryptedResponseData);
    return decryptedData;
  } catch (error) {
    console.error("Error fetching API:", error);
    throw error; // Rethrow error for handling in the calling code
  }
};
